// src/client/dev/react.ts
import { useState } from "react";
function useRegisterSW(_options = {}) {
  const needRefresh = useState(false);
  const offlineReady = useState(false);
  const updateServiceWorker = (_reloadPage) => {
  };
  return {
    needRefresh,
    offlineReady,
    updateServiceWorker
  };
}
export {
  useRegisterSW
};
